const dataLoadableBeginRegex = /data-loadable-begin="([^"]*)"/;
const dataLoadableEndRegex = /data-loadable-end="([^"]*)"/;
const MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER = 2;

function findEndMarker(root: Node, loadableId: string) {
	if (!root) return null;

	let el: Node | null = root;
	while ((el = el.nextSibling)) {
		if (el.nodeType !== Node.COMMENT_NODE) continue;
		const match = el?.nodeValue?.match(dataLoadableEndRegex);
		if (match && match[1] === loadableId) {
			return el;
		}
	}
	return null;
}

/**
 * We have some issue with macro that they are claim to b inline macro but render divs.
 * The problem is we are wrapping the macro in a span because they supposed to be inline.
 * This created problem for SSR result because when parsing Chrome will see this as broken HTML.
 * In stead creating DOM tree like <span><div>...</div></span> it will create <span></span><div>...</div>
 * This made React hydration never successful because by using DOM API you can actually create the broken DOM.
 * This function finds these issues and fix before React hydration.
 */
export function fixUnbalancedPlaceholderCommentMarkers(root: Node = document.body) {
	if (!window.__SSR_RENDERED__) return;

	try {
		const nodes = root.childNodes;
		for (let i = 0; i < nodes.length; i++) {
			const node = nodes[i];

			const nodeType = node.nodeType;
			if (nodeType === Node.COMMENT_NODE) {
				const match = node.nodeValue?.match(dataLoadableBeginRegex);
				if (match) {
					const loadableId = match[1];

					// We found a begin marker
					let insertionPoint = node;
					while (insertionPoint.nextSibling) {
						insertionPoint = insertionPoint.nextSibling;
					}
					if (!insertionPoint.parentNode) {
						continue;
					}

					// Now let's find the end
					let endMarker: Node | null = null;
					let beginMarker: Node = node;
					let moveUpLevelCount = 0;
					while (
						!(endMarker = findEndMarker(beginMarker, loadableId)) &&
						moveUpLevelCount <= MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER
					) {
						// We can't find it, go up a level
						if (beginMarker.parentNode) {
							beginMarker = beginMarker.parentNode;
							moveUpLevelCount++;
						} else {
							break;
						}
					}

					// Now we have a pairing end. Check if they are already siblings
					if (endMarker && endMarker.parentNode === insertionPoint.parentNode) {
						// begin and end are in teh same parent
						continue;
					}

					// Move the nodes
					if (
						endMarker &&
						endMarker.parentNode &&
						beginMarker.parentNode === endMarker.parentNode
					) {
						const nextSibling = endMarker.nextSibling;
						let node: Node | null = endMarker;
						while (node && node !== beginMarker) {
							const previousSibling: Node | null = node.previousSibling;
							insertionPoint.parentNode.insertBefore(node, insertionPoint.nextSibling);
							node = previousSibling;
						}

						/**
						 * <p><span>foo<div>something</div></span>bar</p>
						 * will become
						 * <p><span>foo</span></p><div>something</div>bar<p></p>
						 * Remove the last dangling empty tag
						 */
						if (
							nextSibling instanceof HTMLElement &&
							nextSibling.nodeName === beginMarker.nodeName &&
							!nextSibling.innerHTML
						) {
							nextSibling.parentNode?.removeChild(nextSibling);
						}
					}
				}
			} else if (nodeType === Node.ELEMENT_NODE) {
				fixUnbalancedPlaceholderCommentMarkers(node);
			}
		}
	} catch (e) {
		if (process.env.NODE_ENV !== 'production') {
			// Please don't blow up the whole page
			throw e;
		}
	}
}
